exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2nOyB9YR9svEUGg-zE9QtT{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;-ms-flex-wrap:wrap;flex-wrap:wrap}._2-rMTOXdmCH_1LIMg8_ZnD{top:-2px}", ""]);
// Exports
exports.locals = {
	"reactionsContainer": "_2nOyB9YR9svEUGg-zE9QtT",
	"reactionsContainerCollapsedRP": "_2-rMTOXdmCH_1LIMg8_ZnD"
};